
import React, { useEffect, useState } from 'react';
import { withRouter, RouteComponentProps } from 'react-router-dom';


import FromFile from './FromFile/FromFile';
import FromScanner from './FromScanner/FromScanner';
import FromSharepoint from './FromSharepoint/FromSharepoint';
import { ChoiceGroup, Dropdown, IChoiceGroupOption, IChoiceGroupOptionStyles, Label } from '@fluentui/react';


import { myTheme } from '../../../../assets/styles/my-theme'
import { reduxActions, RootState } from '../../../../store';
import { useSelector } from 'react-redux';
import abilityBuild from '../../../../shared/CASL/appAbility';
import { subject } from '@casl/ability';
import PrintLabel from './PrintLabel/PrintLabel';
import { Wizard_Mode } from '../../../../shared/enums';
import { store } from '../../../..';
const { palette } = myTheme;


const choiceGroupOptionStyles: Partial<IChoiceGroupOptionStyles> = {
    labelWrapper: {
        width: 92,
        fontSize: 13.5
    },
    field: {
        '&.is-checked': {
            color: palette.themePrimary
        },
        '&.is-checked:hover .ms-ChoiceFieldLabel': {
            color: palette.themePrimary
        },
    },
}

export interface UploadFilesProps {
    target: string
    onFileChanged?: () => void;
    onFileSourceChange?: (newValue: string | undefined) => void;
}
type Props = UploadFilesProps & RouteComponentProps

const UploadFiles: React.FunctionComponent<Props> = props => {

    const selectFeatures = (state: RootState) => state.sessionReducer.features;
    const features = useSelector(selectFeatures);

    const selectWizardMode = (state: RootState) => state.protocolWizardReducer.wizardMode;
    const wizardMode = useSelector(selectWizardMode);


    const selectDocumentFileSource = (state: RootState) => state.protocolWizardReducer.documentFileSource;
    const selectAttachmentFileSource = (state: RootState) => state.protocolWizardReducer.attachmentFileSource;
    const selectedFileSource = useSelector(props.target === "documento" ? selectDocumentFileSource : selectAttachmentFileSource);

    const setSelectedFileSource = (fileSource: string) => props.target === 'documento'
        ? store.dispatch(reduxActions.protocolWizardActions.updateProtocolWizardState({ documentFileSource: fileSource }))
        : store.dispatch(reduxActions.protocolWizardActions.updateProtocolWizardState({ attachmentFileSource: fileSource }));

    
    const [fileSourceOptions, setFileSourceOptions] = useState<IChoiceGroupOption[]>([]);

    useEffect(() => {
        if (features) {
            let newFileSourceOptions: IChoiceGroupOption[] = [];

            /// faccio uno switch per configurare i pulsanti in base al wizardMode e alle features
            switch (wizardMode) {
                case Wizard_Mode.Allocated:
                    if (props.target === "allegati") {
                        newFileSourceOptions.push({ key: 'locale', text: 'Locale', iconProps: { iconName: 'FolderSearch' }, styles: choiceGroupOptionStyles });
                    }

                    if (abilityBuild.can('use', subject('IFeature', { key: 'Scanner', enabled: true }))) {
                        newFileSourceOptions.push({ key: 'scanner', text: 'Scanner', iconProps: { iconName: 'Print' }, styles: choiceGroupOptionStyles });
                    }

                    if (props.target === "allegati" && abilityBuild.can('use', subject('IFeature', { key: 'SharePoint', enabled: true }))) {
                        newFileSourceOptions.push({ key: 'sharePoint', text: 'SharePoint', iconProps: { iconName: 'SharepointLogo' }, styles: choiceGroupOptionStyles });
                    }

                    break;
                case Wizard_Mode.Acquired:
                    newFileSourceOptions.push({ key: 'locale', text: 'Locale', iconProps: { iconName: 'FolderSearch' }, styles: choiceGroupOptionStyles });

                    if (abilityBuild.can('use', subject('IFeature', { key: 'Scanner', enabled: true }))) {
                        newFileSourceOptions.push({ key: 'scanner', text: 'Scanner', iconProps: { iconName: 'Print' }, styles: choiceGroupOptionStyles });
                    }

                    if (abilityBuild.can('use', subject('IFeature', { key: 'SharePoint', enabled: true }))) {
                        newFileSourceOptions.push({ key: 'sharePoint', text: 'SharePoint', iconProps: { iconName: 'SharepointLogo' }, styles: choiceGroupOptionStyles });
                    }
                    break;
                case Wizard_Mode.Create:
                case Wizard_Mode.PrintLabel:
                    newFileSourceOptions.push({ key: 'locale', text: 'Locale', iconProps: { iconName: 'FolderSearch' }, styles: choiceGroupOptionStyles });

                    if (abilityBuild.can('use', subject('IFeature', { key: 'Scanner', enabled: true }))) {
                        newFileSourceOptions.push({ key: 'scanner', text: 'Scanner', iconProps: { iconName: 'Print' }, styles: choiceGroupOptionStyles });
                    }

                    if (abilityBuild.can('use', subject('IFeature', { key: 'SharePoint', enabled: true }))) {
                        newFileSourceOptions.push({ key: 'sharePoint', text: 'SharePoint', iconProps: { iconName: 'SharepointLogo' }, styles: choiceGroupOptionStyles });
                    }

                    if (props.target === "documento" && abilityBuild.can('use', subject('IFeature', { key: 'StampaEtichetta', enabled: true }))) {
                        newFileSourceOptions.push({ key: 'stampaEtichetta', text: 'Etichetta', iconProps: { iconName: 'QRCode' }, styles: choiceGroupOptionStyles });
                    }

                    break;
                case Wizard_Mode.CreateFrom:
                case Wizard_Mode.Edit:
                case Wizard_Mode.Reload:
                    newFileSourceOptions.push({ key: 'locale', text: 'Locale', iconProps: { iconName: 'FolderSearch' }, styles: choiceGroupOptionStyles });

                    if (abilityBuild.can('use', subject('IFeature', { key: 'Scanner', enabled: true }))) {
                        newFileSourceOptions.push({ key: 'scanner', text: 'Scanner', iconProps: { iconName: 'Print' }, styles: choiceGroupOptionStyles });
                    }

                    if (abilityBuild.can('use', subject('IFeature', { key: 'SharePoint', enabled: true }))) {
                        newFileSourceOptions.push({ key: 'sharePoint', text: 'SharePoint', iconProps: { iconName: 'SharepointLogo' }, styles: choiceGroupOptionStyles });
                    }

                    break;

            }


            if (newFileSourceOptions.length === 1) {
                setSelectedFileSource(newFileSourceOptions[0].key);
            }
            setFileSourceOptions(newFileSourceOptions);
        }
    }, [features, wizardMode]);

    const sourceTypes = () => {
        switch (selectedFileSource) {
            case 'locale':
                return (
                    <FromFile target={props.target} onFileChanged={props.onFileChanged} />
                );
            case 'scanner':
                return (
                    <FromScanner target={props.target} onFileChanged={props.onFileChanged} />
                );
            case 'sharePoint':
                return (
                    <FromSharepoint target={props.target} onFileChanged={props.onFileChanged} />
                );
            case 'stampaEtichetta':
                return (
                    <PrintLabel />
                );
        }

    }

    const handleSelectedSourceChange = (newValue) => {
        setSelectedFileSource(newValue);
        if (props.onFileSourceChange) {
            props.onFileSourceChange(newValue);
        }
    };



    return <div className="upload-files-component">
        {fileSourceOptions.length > 1 &&
            <ChoiceGroup
                label="Tipo di acquisizione:"
                selectedKey={selectedFileSource}
                options={fileSourceOptions}
                onChange={(ev, option) => handleSelectedSourceChange(option?.key)} />
        }

        {sourceTypes()}

    </ div>

};


export default withRouter(UploadFiles);

